import { gql } from '@efficiently/client-core-graphql-models';

export const CAPTURE_REGISTRATION = gql(`
	mutation CaptureRegistration {
		captureRegistration
	}
`);
